import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import SortableListItem from '@/components/ui/drag-and-drop/sortable-list-item/SortableListItem';
import { Icon, IconButton } from '@monash/portal-react';
import { deepClone, useOnOutsideClick } from '@monash/portal-frontend-common';
import { getShortcutIndex } from '../../utils';
import c from './edit-shortcut-mobile-row.module.scss';
import IconDisplay from '@/components/pages/custom/components/icon-display/IconDisplay';

export const EditShortcutMobileRow = ({
  shortcut,
  setInEditShortcuts,
  setIsListDirty,
  onEdit,
  isFirst,
  isLast,
}) => {
  const ref = useRef(null);
  const [isTapped, setIsTapped] = useState(false);

  useOnOutsideClick({
    refs: [ref],
    fn: () => {
      setIsTapped(false);
    },
  });

  const moveShortcutUp = () => {
    setIsListDirty(true);
    setInEditShortcuts((shortcuts) => {
      const newShortcuts = deepClone(shortcuts);
      const currentIndex = getShortcutIndex(shortcut.id, newShortcuts);
      if (currentIndex > 0) {
        const temp = newShortcuts[currentIndex - 1];
        newShortcuts[currentIndex - 1] = newShortcuts[currentIndex];
        newShortcuts[currentIndex] = temp;
      }
      return newShortcuts;
    });
  };

  const moveShortcutDown = () => {
    setIsListDirty(true);
    setInEditShortcuts((shortcuts) => {
      const newShortcuts = deepClone(shortcuts);
      const currentIndex = getShortcutIndex(shortcut.id, newShortcuts);
      if (currentIndex < newShortcuts.length - 1) {
        const temp = newShortcuts[currentIndex + 1];
        newShortcuts[currentIndex + 1] = newShortcuts[currentIndex];
        newShortcuts[currentIndex] = temp;
      }
      return newShortcuts;
    });
  };

  const deleteInEditShortcut = () => {
    setIsListDirty(true);
    setInEditShortcuts((shortcuts) => {
      const newShortcuts = deepClone(shortcuts);
      const inEditShortcutIndex = getShortcutIndex(shortcut.id, newShortcuts);
      newShortcuts.splice(inEditShortcutIndex, 1);
      return newShortcuts;
    });
  };

  return (
    <SortableListItem
      id={shortcut.id}
      ref={ref}
      className={classNames(c.editableShortcutContainer, {
        [c.isTapped]: isTapped,
      })}
      itemLabel={shortcut.name}
      onClick={() => setIsTapped(true)}
    >
      <span>
        <IconDisplay icon={shortcut.icon} url={shortcut.url} />
      </span>

      <div className={c.name}>{shortcut.name}</div>

      <div className={c.buttons}>
        <IconButton
          onClick={moveShortcutUp}
          className={classNames(c.reorderArrow, {
            [c.disabled]: isFirst,
          })}
          variant="text"
          mode="card"
          icon={Icon.ChevronUp}
          color="var(--card-text-color)"
          size={24}
          aria-label="Move shortcut up"
          disabled={isFirst}
        />
        <IconButton
          onClick={moveShortcutDown}
          className={classNames(c.reorderArrow, {
            [c.disabled]: isLast,
          })}
          variant="text"
          mode="card"
          icon={Icon.ChevronDown}
          color="var(--card-text-color)"
          size={24}
          aria-label="Move shortcut down"
          disabled={isLast}
        />
        <IconButton
          onClick={() => onEdit(shortcut.id)}
          variant="text"
          mode="card"
          icon={Icon.Pencil}
          color="var(--card-text-color)"
          size={24}
          aria-label="Edit shortcut"
        />
        <IconButton
          onClick={deleteInEditShortcut}
          variant="text"
          mode="card"
          icon={Icon.Trash}
          color="var(--color-intent-attention)"
          size={24}
          aria-label="Delete shortcut"
        />
      </div>
    </SortableListItem>
  );
};
